import { render, staticRenderFns } from "./DualGraphicsComponent.vue?vue&type=template&id=0cd08d18&scoped=true"
import script from "./DualGraphicsComponent.vue?vue&type=script&lang=js"
export * from "./DualGraphicsComponent.vue?vue&type=script&lang=js"
import style0 from "./DualGraphicsComponent.vue?vue&type=style&index=0&id=0cd08d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd08d18",
  null
  
)

export default component.exports